export const initialState = {}

export const getPopoverStatus = (state, id) => state.popover && state.popover[id] || undefined


// WEBPACK FOOTER //
// ./src/interface/store/departments/popover/selectors.js